import {AdsSearchKeywordsInput} from '@frontend/modules/public/ads/components/search/AdsSearchKeywordsInput'
import {CategorySelectorDropdown} from '@frontend/modules/public/ads/components/search/CategorySelectorDropdown'
import {CategorySelectorModal} from '@frontend/modules/public/ads/components/search/CategorySelectorModal'
import {LocationSelector} from '@frontend/modules/public/ads/components/search/LocationSelector'
import {
    useAdsStore,
    useUiLayoutStore,
} from '@frontend/stores'
import clsx from 'clsx'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'

// Панель поиска объявлений.
export function AdsSearchPanel() {

    const show = useAdsStore(
        state => state.searchPanel
    )

    const uiLayout = useUiLayoutStore(
        state => state.deviceType
    )

    return (
        <Collapse
            show={show}
            showImmediately
        >
            <div
                id="offered-items-filter"
                className={clsx(
                    'm-0 pt-2 pb-1 d-flex flex-row align-items-stretch justify-content-start',
                    'pt-lg-3',
                    'pt-xl-4'
                )}
            >
                {uiLayout === 'mobile' ? (
                    <CategorySelectorDropdown iconMode />
                ) : (
                    <CategorySelectorModal />
                )}
                <AdsSearchKeywordsInput
                    buttonMode={
                        uiLayout === 'mobile'
                            ? 'floating-icon'
                            : (uiLayout === 'tablet' ? 'icon' : 'button')
                    }
                />
                <LocationSelector iconMode={uiLayout === 'mobile'} />
            </div>
        </Collapse>
    )
}
